"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AboutDescription = exports.AboutCover = exports.AboutCoverBox = exports.AboutBox = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _StyledLayout = require("../../../../../StyledLayout");

var AboutBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__AboutBox",
  componentId: "sc-1fhbpo-0"
})(["background:", ";padding:96px ", ";"], function (props) {
  return props.theme.portfolioBackground2;
}, function (props) {
  return props.theme.spacingSm;
});
exports.AboutBox = AboutBox;
var AboutCoverBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__AboutCoverBox",
  componentId: "sc-1fhbpo-1"
})(["height:100%;width:100%;max-height:400px;max-width:656px;"]);
exports.AboutCoverBox = AboutCoverBox;

var AboutCover = _styledComponents["default"].img.withConfig({
  displayName: "Elements__AboutCover",
  componentId: "sc-1fhbpo-2"
})(["width:100%;height:auto;max-width:656px;max-height:400px;object-fit:contain;"]);

exports.AboutCover = AboutCover;

var AboutDescription = _styledComponents["default"].div.withConfig({
  displayName: "Elements__AboutDescription",
  componentId: "sc-1fhbpo-3"
})(["max-width:656px;p{text-align:center;}"]);

exports.AboutDescription = AboutDescription;